// extracted by mini-css-extract-plugin
module.exports = {"footer":"SG-UT","footer-link":"lbnzG"};